import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { React, useContext } from 'react';
import UserContext from '../components/User_Context';
import { Home_Screen } from '../screens/home_screen';
import { Login_Screen } from '../screens/login_screen';
import { Login_Darm_Screen } from '../screens/darm/login/login_darm';
import { Logout_Screen } from '../screens/logout_screen';
import { DMS_Screen } from '../screens/dms/dms_screen';
import { DMS_Scraper_Screen } from '../screens/dms/scraper/dms_scraper_screen.js';
//import { Chat_Screen } from '../screens/dms/chat_screen';
// import { Chat_Screen_GPT as Chat_Screen } from '../screens/dms/chat_screen_gpt';
import { NewChatScreen as Chat_Screen } from '../screens/dms/chat/new_chat_screen.jsx';
import { Edit_File_Screen } from '../screens/dms/edit/dms_file_edit.js';
import { Queue_Manager_Screen } from '../screens/queue_manager/queue_manager';
import { Users_Groups_Search_Screen } from '../screens/user_groups/usersgroups_search_screen';
import { Users_Profile_Screen } from '../screens/user_groups/user_profile_screen';
import { ChangePasswordScreen } from '../screens/user_groups/change_password_screen.js';
import { BFM_Editor } from '../screens/flow/flow_editor';
import { BFM_Data_Editor } from '../screens/flow/flow_data_editor.js';
import { Vocs_Editor } from "../screens/system/vocs_editor_screen.js";
import Form_Custom_Vocs_Screen from "../screens/system/form_custom_vocs_screen.js";
import { Admin_Screen } from "../screens/system/admin_screen.js";
import { Configurations_Screen } from "../screens/system/configurations_screen.js";
import { Dashboard_Screen } from '../screens/dashboard/dashboard_screen.js';
import { Business_Units_Screen } from '../screens/system/business_units_screen.js'
import { Rights_Tree_Screen } from '../screens/system/rights_tree_screen.js'
import { Requirements_Screen } from '../screens/system/requirements_screen.js'
import { Requirements_Flows_Screen } from '../screens/system/requirements_flows_screen.js'
import { Indicators_Screen } from '../screens/system/indicators_screen.js'
import { Meet_Screen } from "../screens/meet/meet_screen.js";
import { Meet_Jump_Screen } from "../screens/meet/meet_jump_screen.js";
import { Organizational_Chart } from '../screens/system/organizational_chart_screen.js';
import { Requirements_Evaluation_Screen } from '../screens/evaluation/requirements_evaluation_screen.js';
import { Indicators_Evaluation_Screen } from '../screens/evaluation/indicators_evaluations_screen.js';
import Toyota_Gantt from '../screens/activities/toyota_gantt.js';
import Board_Screen from '../screens/activities/board.js';
import ActivityList_Screen from '../screens/activities/activityList.js'
import TaskEditor_Screen from '../screens/activities/taskEditor.js';
import Hand_Hygiene from '../screens/darm/hand_hygiene/hand_hygiene.js'
import { Hand_Hygiene_Finder } from '../screens/darm/hand_hygiene/hand_hygiene_finder.js'
import GeneralReport from '../power-bi/reportPowerBI/GeneralReport.js';
import { Form_Builder } from '../screens/darm/form_builder/form_builder.js';
import { Form_Builder_Finder } from '../screens/darm/form_builder/form_builder_finder.js';
import { ACPM_Finder } from '../screens/darm/form_builder/acpm_finder.js';
import { InvoiceAnalyzerScreen } from '../screens/invoice_analizer_screens.js';
import { Form_Compiler } from '../screens/darm/form_builder/compilerNew.js';
import { Form_Assignment_Screen } from '../screens/darm/form_builder/newAssingment/form_assignment_screen.js';
import Forms_DashBoard from '../screens/darm/form_builder/forms_dashBoard.js';
import NewForm_Dashboard from '../screens/darm/form_builder/dashboard/newForm_dashoard.js';
import Validation_Dashboard from '../screens/darm/form_builder/validation_dashboard.js';
import NewValidation_Dashboard from '../screens/darm/form_builder/dashboard/validation_dashboard.js';
import Editor from '../screens/EditorJS/editor.js';
import OAuth_Callback_Screen from '../screens/callback/OAuth_Callback_Screen.js';
import AfterLogoutScreen from '../screens/service_screen/after_logout_screen.js';
import AfterLoginErrorScreen from '../screens/service_screen/after_login_error_screen.js';
import JumpToFlowise from '../screens/flowise/flowise.jsx';
import { Item_Edit } from '../screens/dms/itemEdit/item_edit_screen.js'
import ReportsDashboard from '../screens/reports/reports_dashboard.js'
import { DataImportScreen } from '../screens/system/data_import_screen.js'
import { AI_Editor_Screen } from '../screens/ai_editor_screen.js'
// Function to determine which login screen to use based on environment profile
const getLoginScreen = () => {
    switch (process.env.REACT_APP_PROFILE) {
        case 'DARM':
            return <Login_Darm_Screen />;
        default:
            return <Login_Screen />;
    }
};

function Site_Routing(props) {
    const { currentUser } = useContext(UserContext);

    if (currentUser()) {
        return (
            <Router>
                <Routes>

                    <Route
                        path="/darm/reports/:reportKey"
                        element={<GeneralReport />}
                    ></Route>

                    <Route
                        path="darm/handHygiene/:id?"
                        element={<Hand_Hygiene />}
                    ></Route>

                    <Route
                        path="/darm/handHygiene/finder"
                        element={<Hand_Hygiene_Finder />}
                    ></Route>

                    <Route
                        path="/toyota"
                        element={<Toyota_Gantt />}
                    />
                    <Route
                        path="/logout"
                        element={<Logout_Screen />}
                    />
                    <Route
                        path="/dms/:id?"
                        element={<DMS_Screen />}
                    />
                    <Route
                        path="/dms/scraper/:id?"
                        element={<DMS_Scraper_Screen />}
                    />
                    <Route
                        path="/aipackages"
                        element={<DMS_Screen mode={`ai-package`} />}
                    />
                    <Route
                        path="/dms/chat/:id"
                        element={<Chat_Screen />}
                    />
                    <Route
                        path="/dms/chat/folder/:folder_id"
                        element={<Chat_Screen />}
                    />
                    <Route
                        path="/dms/edit/:id?"
                        element={<Edit_File_Screen />}
                    />

                    <Route
                        path="/editor/:id?"
                        element={<Editor />}
                    />

                    <Route
                        path="/invoice/analyze/:id"
                        element={<InvoiceAnalyzerScreen />}
                    />

                    <Route
                        path="/queueManager"
                        element={<Queue_Manager_Screen />}
                    />

                    <Route
                        path="/aiflow/:id"
                        element={<BFM_Editor />}
                    />

                    <Route
                        path="/aiflow/data/:id"
                        element={<BFM_Data_Editor />}
                    />

                    <Route
                        path="/admin"
                        element={<Admin_Screen />}
                    />

                    <Route
                        path="/admin/data-import"
                        element={<DataImportScreen />}
                    />

                    <Route
                        path='/admin/users_and_groups'
                        element={<Users_Groups_Search_Screen />}
                    />

                    <Route
                        path="/admin/user/:id?"
                        element={<Users_Profile_Screen type="user" />}
                    />

                    <Route
                        path="/admin/group/:id?"
                        element={<Users_Profile_Screen type="group" />}
                    />
                    
                    <Route
                        path="/change-password"
                        element={<ChangePasswordScreen />}
                    />

                    <Route
                        path="/admin/vocs/:voc_id"
                        element={<Vocs_Editor />}
                    />

                    <Route
                        path="/admin/form_custom_vocs"
                        element={<Form_Custom_Vocs_Screen />}
                    />

                    <Route
                        path="/admin/configurations"
                        element={<Configurations_Screen />}
                    />

                    <Route
                        path="/admin/organization/business_units"
                        element={<Business_Units_Screen />}
                    />

                    <Route
                        path="/admin/security/rights_tree"
                        element={<Rights_Tree_Screen />}
                    />

                    <Route
                        path="/requirements"
                        element={<Requirements_Screen />}
                    />

                    <Route
                        path="/admin/requirements/flows"
                        element={<Requirements_Flows_Screen />}
                    />
                    <Route path='/requirements/evaluation/:requirementId/:organizationalUnitId?'
                        element={<Requirements_Evaluation_Screen />}
                    />
                    <Route path='/indicators/evaluation/:indicatorId/:organizationalUnitId?'
                        element={<Indicators_Evaluation_Screen />}
                    />
                    <Route
                        path="/admin/indicators"
                        element={<Indicators_Screen />}
                    />

                    <Route
                        path="/dashboard"
                        element={<Dashboard_Screen />}
                    >
                    </Route>

                    <Route
                        path="/reports"
                        element={<ReportsDashboard />}
                    />
                    
                    <Route
                        path="/ai-editor"
                        element={<AI_Editor_Screen />}
                    />

                    <Route
                        path="/meet/:id?"
                        element={<Meet_Screen />}
                    >
                    </Route>
                    <Route
                        path="/meet/jump/:url?"
                        element={<Meet_Jump_Screen />}
                    >
                    </Route>
                    <Route
                        path="/admin/organization/unit_chart/:id?"
                        element={<Organizational_Chart />}
                    >
                    </Route>
                    <Route
                        path="/activity/board"
                        element={<Board_Screen />}
                    >
                    </Route>
                    <Route
                        path="/activity/activityList/:id"
                        element={<ActivityList_Screen />}
                    >
                    </Route>
                    <Route
                        path="/activity/task/:id"
                        element={<TaskEditor_Screen />}
                    >
                    </Route>
                    <Route
                        path="/form_builder/:id?"
                        element={<Form_Builder />}
                    >
                    </Route>
                    <Route
                        path="/form_builder/finder"
                        element={<Form_Builder_Finder />}
                    >
                    </Route>
                    <Route
                        path="/acpm/finder/:formId?"
                        element={<ACPM_Finder />}
                    >
                    </Route>
                    <Route
                        path="/form_builder/dashboard/:formId?"
                        // element={<Forms_DashBoard />}
                        element={<NewForm_Dashboard />}

                    >
                    </Route>
                    {/* <Route
                        path="/form_builder/validation"
                        element={<Validation_Dashboard />}
                    >
                    </Route> */}
                    <Route
                        path="/form_builder/validation"
                        element={<NewValidation_Dashboard />}
                    >
                    </Route>

                    <Route
                        path="/form/compile/:formId"
                        element={<Form_Compiler />}
                    >
                    </Route>
                    <Route
                        path="/form/compile/:formId/:completionId"
                        element={<Form_Compiler />}
                    >
                    </Route>
                    <Route
                        path="/form/assignments/:formId?"
                        element={<Form_Assignment_Screen />}
                    >
                    </Route>
                    <Route
                        path="/flowise"
                        element={<JumpToFlowise />}
                    >
                    </Route>
                    <Route
                        path="*"
                        element={<Dashboard_Screen />}
                    />
                    <Route
                        path="/auth/callback"
                        element={<OAuth_Callback_Screen />}
                    >

                    </Route>
                       <Route
                        path="/changePassword"
                        element={<ChangePasswordScreen />}
                    ></Route>
                       <Route
                        path="dms/itemEdit/:type/:id"
                        element={<Item_Edit />}
                    ></Route>
                    Item_Edit
                </Routes>
                {props.children}
            </Router>
        );
    }
    else {
        return (
            <Router>
                <Routes>
                <Route
                path="/afterLogout"
                element={<AfterLogoutScreen/>}>

                </Route>
                <Route
                path="/afterLoginError"
                element={<AfterLoginErrorScreen/>}>

                </Route>
                    <Route
                        path="/meet/:url?"
                        element={<Meet_Screen />}
                    >
                    </Route>
                    <Route
                        path="/meet/jump/:url?"
                        element={<Meet_Jump_Screen />}
                    >
                    </Route>
                    <Route
                        path="/auth/callback"
                        element={<OAuth_Callback_Screen />}
                    ></Route>
                    <Route
                        path="*"
                        element={getLoginScreen()}
                    />
                     <Route
                        path="/login/:local?"
                        element={getLoginScreen()}
                    />
                </Routes>
            </Router>
        );
    }

}

export default Site_Routing;